import { Editor, Node, Transforms } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function setNodes(editor: Editor, props: Partial<Node>, options?: WithQueryOptions<typeof Transforms.setNodes, 2>) {
    return Transforms.setNodes(editor, props, getQueryOptions(editor, options));
}
